import { httpDelete, httpGet, httpPost, httpPut } from '@pressreader/services';

import type {
    CollectionFeedDto,
    CollectionsDto,
    CollectionsFeedControl,
    LinkedCollectionDto,
    LinkedCollectionsDto,
    ManageUserCollectionDto,
    UserCollectionDto,
} from '../types';

import { disableRetryParam } from './constants';

function getCollections() {
    return httpGet<CollectionsDto>('collections');
}

function createUserCollection(data: ManageUserCollectionDto) {
    return httpPost<UserCollectionDto>('collections', '', data, disableRetryParam);
}

function removeUserCollection(collectionId: string) {
    return httpDelete('collections', collectionId, disableRetryParam);
}

function updateUserCollection(collectionId: string, data: ManageUserCollectionDto) {
    return httpPut('collections', collectionId, data, disableRetryParam);
}

function getCollectionsOf(profileId: string) {
    return httpGet<CollectionsDto>('user', `${profileId}/collections`);
}

async function getCollectionFeed(profileId: string, collectionId: string, data: CollectionsFeedControl): Promise<CollectionFeedDto | null> {
    if (!profileId) {
        throw new Error('ProfileId not specified');
    }
    if (data.limit > 0) {
        return httpGet<CollectionFeedDto>('users', `${profileId}/collections/${collectionId}/items`, data);
    }
    return null;
}

async function getLinkedCollections(cid: string): Promise<LinkedCollectionDto[]> {
    const result: LinkedCollectionsDto = await httpGet('v1/publications', `${cid}/linkedcollections`);
    return result.items;
}

export {
    createUserCollection,
    getCollectionFeed,
    getCollections,
    getCollectionsOf,
    getLinkedCollections,
    removeUserCollection,
    updateUserCollection,
};
